// extracted by mini-css-extract-plugin
export default {"container":"LanguageCard_container__Ohh1w","subContainer":"LanguageCard_subContainer__PfCpJ","elements":"LanguageCard_elements__hXlt+"};